import $ from 'jquery';

$('#user_login').wrap('<div class="is-required"<div/>')
$('#user_email').wrap('<div class="is-required"<div/>')

$('#registerform').submit(function () {
    // e.preventDefault();
    const data = $(this).serializeArray();
    const json_str = JSON.stringify(data);

    createCookie('formCookie', json_str);
});

$('#registerform input:checkbox').focus(function() {
    $('.acf-true-false').css('border', '1px solid #8533b0');
});

$('#registerform input:checkbox').blur(function() {
  $('.acf-true-false').css('border', '1px solid #e5e0e3');
});

$(document).ready(function () {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    Object.entries(params).forEach(([key, value]) => {
        if (key === 'empty_username') {
            key = 'user_login'
        }
        if (key === 'empty_email') {
            key = 'user_email'
        }
        if (key === 'invalid_email') {
            key = 'user_email'
        }
        if (key === 'email_exists') {
            $('.form-block').prepend('<h4 class="error">Така пошта вже зареєстрована</h4>')
            $('#registerform').find('input[type="email"]').css("border-color", "red");
        }
        if (key === 'invalid_username') {
            $('.form-block').prepend('<h4 class="error">Не вірно вказан логін</h4>')
            $('#registerform').find('input[name="user_login"]').css("border-color", "red");
        }
        if (key === 'username_exists') {
            $('.form-block').prepend('<h4 class="error">Такий логін вже існує</h4>')
            $('#registerform').find('input[name="user_login"]').css("border-color", "red");
        }
        $('#registerform').find(`#${key}`).css("border-color", "red");
        $('#registerform').find(`#${key}`).closest('.acf-true-false').css("border-color", "red");
        console.log(value);
    });

    if (window.location.href.indexOf("validation") > -1) {
        let result = JSON.parse(getCookie('formCookie'));
            for(var k in result) {
                let formInput = $('#registerform').find(`input[name='${result[k].name}']` )
                formInput.val(`${result[k].value}`);
            }
    }
});

function createCookie(name, value, days) {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    }
    else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
}

const getCookie = (name) => {
    return document.cookie.split("; ").reduce((r, v) => {
      const parts = v.split("=")
      return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, "")
}

$('.acf-true-false .message').click(function(){
    if ($('.acf-true-false #acf-field_62a847ba0db43').is(":checked")) {
        $('.acf-true-false #acf-field_62a847ba0db43').val('0');
        $('.acf-true-false input[type=hidden]').val('0')
    } else {
        $('.acf-true-false #acf-field_62a847ba0db43').val('1');
        $('.acf-true-false input[type=hidden]').val('1');
    }
})

$(document).ready(function () {
    if ($('.acf-true-false input[type=hidden]').val('0')) {
        $('.acf-true-false #acf-field_62a847ba0db43').val('0');
    }
});